/**
 * Add a new invoice
 *
 * @param invoice
 * @returns {function(*)}
 */
import {addNotification as notify} from 'reapop';
import * as invoiceActions from "../graphql/actions/invoice";
import l10n from "../l10n/localization";
import * as types from "../constants/actionTypes";
import * as fogActions from "./fog";
import * as creationActions from "./creation";

export function add(invoice) {
    let isArchived = invoice.archived;
    delete invoice.archived;

    return dispatch => {
        dispatch(loading());
        dispatch(saving(invoice));
        invoiceActions.add(
            function (response) {
                dispatch(saved(response.data.createInvoice));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
                dispatch(fogActions.fetchFogs(true, isArchived));
                dispatch(creationActions.receivednewlyCreatedInvoice(response.data.createInvoice));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            invoice
        );
    };
}


export function edit(invoice) {
    let id = invoice.id;
    let isArchived = invoice.archived;
    delete invoice.id;
    delete invoice.__typename;
    delete invoice.archived;

    return dispatch => {
        dispatch(loading());
        dispatch(saving(invoice));
        invoiceActions.edit(
            function (response) {
                dispatch(saved(response.data.editInvoice));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
                dispatch(fogActions.fetchFogs(true, isArchived));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            id,
            invoice
        );
    };
}


export function fetchInvoices(fogId, force = false) {
    return dispatch => {
        dispatch(loading());
        invoiceActions.getInvoices(
            function (response) {
                dispatch(receiveInvoices(response.data.invoices));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
            },
            fogId,
            force
        );
    };
}


export function get(id, force = false) {
    return dispatch => {
        dispatch(loading());
        invoiceActions.get(
            function (response) {
                dispatch(receiveInvoice(response.data.invoice));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
            },
            id,
            force
        );
    };
}

export function remove(id) {

    return dispatch => {
        dispatch(loading());
        invoiceActions.remove(
            function () {
                dispatch(notify({message: l10n.messages.removed, status: 'success'}));
                dispatch(fogActions.fetchFogs(true));
                dispatch(removed());
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            id
        );
    };
}

export function removed() {
    return {
        type: types.REMOVED_INVOICE
    };
}


export function loading() {
    return {
        type: types.LOADING_INVOICE
    };
}

export function errorSaving() {
    return {
        type: types.ERROR_SAVING_INVOICE,
    };
}

export function saving(invoice) {
    return {
        type: types.SAVING_INVOICE,
        payload: invoice
    };
}

export function saved(invoice) {
    return {
        type: types.SAVED_INVOICE,
        payload: invoice
    };
}

export function receiveInvoices(data) {
    return {
        type: types.RECEIVED_INVOICES,
        payload: data
    };
}

export function receiveInvoice(data) {
    return {
        type: types.RECEIVED_INVOICE,
        payload: data
    };
}

export function errorMessage(message) {
    return dispatch => {
        dispatch(notify({message: message, status: 'error',dismissAfter: 8000}));
    };
}


// WEBPACK FOOTER //
// ./src/actions/invoice.js